













































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Form as ElForm } from 'element-ui';
import { State } from 'vuex-class';
import { updatePwd } from '@/api/login';
const namespace = 'user';
@Component({})
export default class ChangePwd extends Vue {
  @State('userInfo', { namespace }) userInfo!: any;
  private captcha: any = process.env.VUE_APP_API + '/account/captcha';
  private form: any = {
    oldPwd: '',
    newPwd: '',
    againPwd: '',
    captcha: ''
  };
  private validatePass(rule: any, value: any, callback: Function) {
    if (!value) {
      callback(new Error('请输入密码'));
    } else if (!/^[A-Za-z0-9]{6,16}$/.test(value)) {
      callback(new Error('密码应为6~16位英文大小写字母或数字的组合'));
    } else {
      if (rule.field === 'newPwd') {
        if (value === this.form.oldPwd) {
          callback(new Error('新密码与旧密码相同'));
        }
      }
      callback();
    }
  }
  private validatePass2(rule: any, value: any, callback: Function) {
    if (!value) {
      callback(new Error('请输入确认密码'));
    } else if (value !== this.form.newPwd) {
      callback(new Error('两次输入密码不一致'));
    } else {
      callback();
    }
  }
  private rules: any = {
    oldPwd: [{ required: true, validator: this.validatePass, trigger: 'blur' }],
    newPwd: [{ required: true, validator: this.validatePass, trigger: 'blur' }],
    againPwd: [
      { required: true, validator: this.validatePass2, trigger: 'blur' }
    ],
    captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
  };

  private mounted() {
    this.updateCaptcha();
  }

  private updateCaptcha() {
    this.captcha =
      process.env.VUE_APP_API + '/account/captcha?r=' + Math.random();
  }

  private onSubmit() {
    const ref = this.$refs.form as ElForm;
    ref.validate(async valid => {
      if (valid) {
        try {
          const obj = {
            id: this.userInfo.id,
            oldPwd: this.form.oldPwd,
            newPwd: this.form.newPwd,
            captcha: this.form.captcha
          };
          await updatePwd(obj);
          this.$message.success('密码更新成功');
          ref.resetFields();
          this.updateCaptcha();
        } catch (err) {
          this.$message.error(err.message);
        }
      } else {
        this.$message.warning('请填写完整');
        return false;
      }
    });
  }
}
